export default {
  'Welcome!': 'Välkommen!',
  'Joint ID': 'Skarv-ID',
  'Joint Log': 'Svetsrapport',
  'Home': 'Hem',
  'ID': 'ID',
  'Reminder': 'Påminnelse/Notis',
  'Reminder: ': 'Påminnelse: ',
  'Alarm': 'Alarm',
  'temps': 'Temperaturer °C',
  'Temperature': 'Temperatur',
  'Joints': 'Skarvar',
  'Current Report': 'Valda rapportrader',
  'Current Equipment': 'Nuvarande hyrd utrustning',
  'Joints welded over time': 'Antal svetsade skarvar över tid',
  'Equipment': 'Utrustning',
  ' Equipment': 'Utrustning',
  'Timestamp': 'Tidsstämpel',
  'timestamp': 'Tidsstämpel',
  'Welds': 'Svetsningar',
  'Actions': 'Åtgärder',
  'Report Preview': 'Förhandsgranska',
  'Page:': 'Sida:',
  'Filters': 'Filter',
  'This Week': 'Denna vecka',
  'This Month': 'Denna månad',
  'This Year': 'I år',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Januari_Februari_Mars_April_Maj_Juni_Juli_Augusti_September_Oktober_November_December',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Må_Ti_On_To_Fr_Lö_Sö',
  'Previous': 'Föregående',
  'Reloading data..': 'Uppdaterar tabellen..',
  'Data reloaded': 'Tabellen uppdaterad',
  'Add to report': 'Lägg till i rapport',
  'Next': 'Nästa',
  'Rental Start Date': 'Startdatum hyrperiod',
  'Rental End Date': 'Slutdatum hyrperiod',
  'Map': 'Karta',
  'Password': 'Lösenord',
  'The password is required!': 'Vänligen ange lösenord!',
  'Password must be at least {1} characters': 'Lösenordet måste vara minst {1} tecken',
  'Create User': 'Skapa användare',
  'First Name': 'Förnamn',
  'Last Name': 'Efternamn',
  'E-mail': 'E-post',
  'User list': 'Användare',
  'Create new user': 'Skapa ny användare',
  'Edit': 'Redigera',
  'Delete': 'Radera',
  'User Profile': 'Användarprofil',
  'Save': 'Spara',
  'User Companies': 'Företagsbehörigheter',
  'Select companies': 'Välj företag',
  'Save Companies': 'Spara företag',
  'Welding Report': 'Svetsrapport',
  'Welding Machine': 'Svetsmaskin',
  'Welding Machines': 'Svetsmaskiner',
  'Created by:': 'Skapad av:',
  'Company:': 'Företag:',
  'of': 'av',
  'Remove': 'Radera',
  'Clear Report': 'Rensa allt',
  'Preview Report': 'Förhandsgranska',
  'Print Report': 'Skriv ut',
  'Are you sure?': 'Är du säker?',
  'Sign In to your account': 'Logga in nedan för att komma åt MittLog-portalen.',
  'Email': 'E-post',
  'Forgot password?': 'Glömt lösenordet?',
  'Logging in..': 'Loggar in..',
  'Access Denied': 'Inloggning misslyckades',
  'Map (Only shows welding machines)': 'Karta (Visar endast svetsmaskiner)',
  'All': 'Alla',
  'Machine ID': 'Maskin-ID',
  'icon-110': 'icon-power',
  'Ongoing': 'Pågående',
  'Historical equipment rentals': 'Tidigare hyrd utrustning',
  'On': 'På',
  'Off': 'Av',
  'Equipment ID (If applicable)': '',
  'Description': '',
  'Write a description of what happened..': '',
  'Alert customer to send back equipment': '',
  'Date': 'Datum',
  'Reason': 'Anledning',
  'Created by': 'Skapad av',
  'Customer Log': 'Kundlogg',
  'Create Log Entry': '',
  'Support - Phone': 'Support - Telefon',
  'Support - E-mail': 'Support - Mejl',
  'Sales - Phone': 'Säljsamtal - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Säljaktivitet - Kampanj, Mejl etc.',
  'Slug': 'Slug',
  'Subject': 'Ämne',
  'Email Templates': 'Mejl-mallar',
  'Revision Date': 'Revisionsdatum',
  'CPU': 'CPU',
  'Filename 1': 'Filnamn 1',
  'Filename 2': 'Filnamn 2',
  'Revisions': 'Revisioner',
  'Revision': 'Revision',
  'Upload new revision': 'Ladda upp ny revision',
  'Equipment ID': 'Utrustnings-ID',
  '# CPUs': '# CPUer',
  'Create Equipment Specification': 'Skapa Maskinspecifikation',
  'Display': 'Display',
  'Styrkort': 'Styrkort',
  'Latest rev CPU 1': 'Senaste rev CPU 1',
  'Latest rev CPU 2': 'Senaste rev CPU 2',
  'Equipment Specifications': 'Maskinspecifikation',
  'Create specification': 'Skapa specifikation',
  'Old': 'Gammalt',
  'New': 'Nytt',
  'Create Update Entry': 'Skapa uppdateringsjobb',
  'Update Queue': 'Uppdateringskö',
  'Create update entry': 'Skapa uppdateringsjobb',
  '[Welcome Title]': 'Välkommen, ',
  '[Welcome Body]': 'Denna portal ger dig insikt i detaljerna kring de svetsningar som görs på ert företag. Använd menyn till vänster för att navigera.',
  'Number of joints': 'Antal skarvar',
  'Dimension': 'Dimension',
  'Select a Machine ID': 'Välj ett Maskin-ID',
  'Choose the equipment related to your message (optional)': 'Välj den utrustning som ärendet rör (frivilligt)',
  '-- Nothing Selected --': '-- Ingen vald --',
  'Message': 'Meddelande',
  'Write your message here': 'Skriv ditt meddelande här',
  'I want to send back the equipment': 'Jag vill skicka tillbaka utrustningen',
  'Contact Support': 'Kontakta Support',
  'Send message': 'Skicka meddelande',
  'Login': 'Logga in',
  'Logout': 'Logga ut',
  'Users': 'Användare',
  'Firmware Revisions': 'Mjukvaror',
  'Equipment Spec.': 'Maskinspec.',
  'Remote Update': 'Fjärruppdatering',
  'Dashboard': 'Översikt',
  'Current': 'Nuvarande',
  'Historical': 'Historik',
  'Weld Report': 'Svetsrapport',
  'Weld Report for ': 'Svetsrapport för ',
  'Support': 'Support',
  'joint_time_a': 'Total svetstid',
  'u_mains': 'Spänning',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Kanal',
  'dimension': 'Dimension',
  'name': 'Namn',
  'Report Name:': 'Rapportnamn:',
  'Comment': 'Kommentar',
  'Joint Comment': 'Kommentar',
  'Write a report name.. (optional)': 'Skriv ett rapportnamn.. (valfritt)',
  'Report name:': 'Rapportnamn:',
  'Add all to report': 'Lägg till alla',
  'Per page': 'Antal per sida',
  'ALARM-0': 'Inget larm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sek',
  'Seconds': 'Sekunder',
  'Minutes': 'Minuter',
  'Select a Dimension': 'Filtrera på dimension',
  'Customer': 'Kund',
  'Work Order': 'Arbetsorder',
  'Draft': 'Utkast',
  'New Picklist': 'Ny plocklista',
  'All Picklists': 'Alla plocklistor',
  'Title': 'Titel',
  'Start date': 'Startdatum',
  'End date': 'Slutdatum',
  'Responsible seller': 'Ansvarig säljare',
  'Street address': 'Gatuadress',
  'Zip code': 'Postnummer',
  'City': 'Stad',
  'Customer Project/Reference': 'Kundens projekt/ref.',
  'Project Phase': 'Kundens etapp',
  'Coil To': 'Slinga tillopp',
  'Coil From': 'Slinga retur',
  'Coil VV/VVC': 'Slinga VV/VVC',
  'Pipe manufacturer': 'Rörtillverkare',
  'Base city': 'Basort',
  'Isolation To': 'Isolation tillopp',
  'Isolation From': 'Isolation retur',
  'Discrepancy report': 'Avvikelserapport',
  'Density test': 'Täthetsprovning',
  'Temp outside': 'Temp ute',
  'Coil Twin': 'Slinga twin',
  'Isolation Twin': 'Isolation twin',
  'Alarm connected': 'Larm kopplat',
  'Had blueprint': 'Larmritning fanns',
  'Work description': 'Arbetsbeskrivning',
  'Work done by': 'Arbetet utfört av',
  'Work orders': 'Arbetsordrar',
  'Contact': 'Kontakt',
  'Back': 'Bakåt',
  'Print': 'Skriv ut',
  'Articles': 'Artiklar',
  'Created': 'Skapad',
  'Update': 'Uppdatera',
  'Article': 'Artikel',
  'Quantity': 'Antal',
  'Quantity missing': 'Antal saknas',
  'Unit': 'Enhet',
  'Work Orders': 'Arbetsordrar',
  'New Work Order': 'Ny arbetsorder',
  'View my work orders': 'Mina arbetsordrar',
  'All Orders': 'Alla',
  'Job Reporting': 'Jobbrapportering',
  'Create new work order': 'Skapa ny arbetsorder',
  'bend': 'böj',
  'Person': 'Person',
  'MSI': 'MSI',
  'Information': 'Information',
  'Work Order List': 'Arbetsordrar',
  'All work orders': 'Alla arbetsordrar',
  'Mine': 'Mina ordrar',
  'My work orders': 'Mina arbetsordrar',
  'Ready for invoicing': 'Klar för fakturering',
  'Info': 'Info',
  'Printed': 'Utskrivna',
  'Not printed': 'Ej utskrivna',
  'Status': 'Status',
  'Overview': 'Översikt',
  'Rak': 'Rak',
  'TSC': 'TSC',
  'Krymp': 'Krymp',
  'TSC-Krymp': 'TSC-Krymp',
  'TSC dn': 'TSC Dy',
  'Twin': 'Twin',
  'Gir >3gr': 'Gir >3gr',
  'Reduction': 'Reduktion',
  'Incl. sleeve': 'Inkl. muff',
  'End sleeve': 'Ändmuff',
  'Rep': 'Rep',
  'Protective sleeve': 'Skyddsmuff',
  'Add': 'Lägg till',
  'T-stycke': 'T-stycke',
  'Single T-Pipe': 'Enkelt T-stycke',
  'Double T-Pipe': 'Dubbelt T-stycke',
  'Stam dn': 'Stam Dy',
  'Avg dn': 'Avg Dy',
  'Lilla dn': 'Lilla Dy',
  'Stam red 1 dn': 'Stam red 1 Dy',
  'Stam red 2 dn': 'Stam red 2 Dy',
  'Select': 'Välj',
  'Avgrening 45gr': 'Avgrening 45gr',
  'Avgrening 90gr': 'Avgrening 90gr',
  'Stam Reduction': 'Stamreduktion',
  'Böj': 'Böj',
  'Angle up to 45°': 'Böj upp till 45°',
  'Angle more than 45°': 'Böj mer än 45°',
  'Quick add': 'Snabbval',
  'Search articles': 'Sök artikel',
  'Select an article': 'Välj artikel',
  'Add article': 'Lägg till artikel',
  'Customers': 'Kunder',
  'Admin': 'Admin',
  'Create new article': 'Skapa ny artikel',
  'Art. No': 'Art. No',
  'Default unit': 'Standardenhet',
  'Favorite': 'Favorit',
  'Clear': 'Rensa val',
  'Set status printed': 'Ändra status till Utskriven',
  'Set status ready for invoicing': 'Sätt status Klar för fakturering',
  'If you have alarm values, please input them below.': 'Om du har alarm-värden måste dessa fyllas i nedan.',
  'Change password': 'Ändra lösenord',
  'Old password': 'Gammalt lösenord',
  'New password': 'Nytt lösenord',
  'Enter new password again': 'Ange det nya lösenordet igen',
  'Minimum 6 characters': 'Minimum 6 tecken',
  'Order responsible': 'Orderansvarig',
  'stored': 'Internt ID',
  'Add new rental': 'Ny uthyrning',
  'New status': 'Ny status',
  'New customer': 'Ny kund',
  'Because the new status is to Service the customer will automatically be set to Mittel :)': 'Eftersom status är Service så kommer kunden automatiskt sättas till Mittel',
  'New rental start date': 'Startdatum',
  'Cancel': 'Avbryt',
  'Rental': 'Uthyrning',
  'Create rental': 'Skapa uthyrning',
  'Search equipment': 'Sök utrustning',
  'Search customer': 'Sök kund',
  'Ort/Placering': 'Ort/Placering',
  'Contact person': 'Kundens kontaktperson',
  'Sales responsible': 'Säljansvarig',
  'End last rental period': 'Avsluta föregående uthyrningsperiod för utrustningen',
  'All Rentals': 'Alla uthyrningar',
  'Search..': 'Sök..',
  'Type': 'Typ',
  'Company': 'Kund',
  'Ort': 'Ort',
  'Rentals': 'Uthyrningar',
  'Model': 'Modell',
  'Model (optional)': 'Modell (frivilligt)',
  'Equipment Number': 'Utrustnings-ID',
  'Serial no is required': 'Serienummer är obligatoriskt',
  'Serial must be at least {1} characters': 'Serienumret behöver vara minst {1} tecken',
  'Hidden': 'Dold',
  'Comment (optional)': 'Kommentar (frivillig)',
  'Create Equipment': 'Skapa utrustning',
  'Equipment list': 'Utrustning',
  'Create new equipment': 'Skapa ny utrustning',
  'New Rental': 'Ny uthyrning',
  'Equipment Type': 'Utrustningstyp',
  'Equipment Model': 'Utrustningsmodell',
  'Remember me': 'Kom ihåg mig',
  'First name': 'Förnamn',
  'Last name': 'Efternamn',
  'Phone': 'Telefon',
  'Only active rentals': 'Endast aktiva uthyrningar',
  'S-angle': 'S-böj',
  'Write a reminder here..': 'Skriv påminnelse här..',
  'Edit equipment': 'Redigera utrustning',
  'Hide from other parts of portal?': 'Dölj från andra delar av portalen?',
  'Equipment Types': 'Utrustningstyper',
  'Create new equipment type': 'Skapa ny utrustningstyp',
  'Create Equipment Type': 'Skapa utrustningstyp',
  'Type Number (ex. 110)': 'Typnummer (ex. 110)',
  'Type name': 'Typnamn',
  'Create new equipment model': 'Skapa ny utrustningsmodell',
  'Equipment Models': 'Utrustningsmodeller',
  'Create Equipment Model': 'Skapa utrustningsmodell',
  'Model name': 'Modellnamn',
  'Name': 'Namn',
  'Edit Equipment Model': 'Redigera utrustningsmodell',
  'Create New Work Order': 'Skapa ny arbetsorder',
  'Latest audit': 'Inv. i år',
  ' Mark as audited': ' Markera som inventerad',
  'STOCK_AUDIT': 'Inventering',
  'GENERAL_COMMENT': 'Notering',
  'Equipment Comment Log': 'Utrustningslogg',
  'Add comment for equipment: ': 'Lägg till kommentar för utrustning: ',
  'FoamCalc': 'SkumCalc',
  'Density mix': 'Densitet mix (oskummad)',
  'Calculate empty volume': 'Räkna tom volym',
  'Density': 'Densitet',
  'Weld type': 'Skarvtyp',
  'ISO:Poly Weight Ratio': 'ISO:Poly viktförhållande',
  'Plastic (mm)': 'Plast (mm)',
  'Steel (mm)': 'Stål (mm)',
  'Length (cm)': 'Längd (cm)',
  'Shortcuts': 'Snabbgenvägar',
  'Temporary rentals': 'Tillfälliga uthyrningar',
  'View alert lists': 'Visa larmlista',
  'Add new contact for customer': 'Lägg till ny kundkontakt',
  'processDone': 'Svetsning slutförd',
  'Yes': 'Ja',
  'No': 'Nej',
  'Show hidden equipment': 'Visa dold utrustning',
  'Knowledge Base': 'Kunskapsdatabas',
  'Green': 'Grön',
  'Yellow': 'Gul',
  'Length (default 75m if not specified)': 'Längd (tomt = 75m)',
  '1. Choose number of fläta to create and default settings': '1. Ange antal, längd och intern/extern',
  '2. Edit details if needed': '2. Granska/redigera enskilda flätrullar',
  'Latest ID:': 'Senaste ID',
  'Quality': 'Kvalitet',
  'Length': 'Längd',
  'Internal': 'Internt',
  'Create': 'Skapa',
  'It seems like this work order already exists in BC with order number: ': 'Det verkar som att denna arbetsorder redan finns i BC med ordernummer: ',
  'This work order will not be sent to BC again. Please edit the existing work order in BC instead.': 'Arbetsordern kommer inte skickas igen. Vänligen redigera ordern direkt i BC istället.',
  'Stocked date': 'Lagerförd',
  'Checkout fläta': 'Checka ut fläta',
  'Add to checkout': 'Lägg till i utcheckning',
  'Color': 'Färg',
  'Sent Date': 'Skickat datum',
  'Nothing selected': 'Inget valt',
  'Filter by status': 'Filtrera status',
  'Sent by': 'Skickad av',
  'Create work order with article': 'Skapa arbetsorder med artikeln',
  'Sync BC': 'Synka med BC',
  'New Flata': 'Ny fläta',
  'My Profile': 'Min profil',
  'Draft picklists': 'Utkast plocklistor',
  'Printed picklists': 'Utskrivna plocklistor',
  'Picklists': 'Plocklistor',
  'Create New Picklist': 'Skapa ny plocklista',
  'Picklist': 'Plocklista',
  'Reference': 'Märke',
  'Order date': 'Orderdatum',
  'Order Contact Person': 'Leveranskontaktperson',
  'Zip Code': 'Postnummer',
  'Shipping address': 'Leveransadress',
  'Shipping city': 'Leveransstad',
  'Shipping country': 'Leveransland',
  'Billing address': 'Fakturaadress',
  'Billing city': 'Fakturastad',
  'Billing country': 'Fakturaland',
  'Use same address for shipping': 'Använd samma adress som leveransadress',
  'blueprint': 'ritning',
  'Blueprint': 'Ritning',
  'Name/Company': 'Namn/Företag',
  'Audit Stock': 'Inventera',
  'From ID': 'Från ID',
  'To ID': 'Till ID',
  'Selected equipment': 'Vald utrustning',
  'The fields below might be filled in automatically based on the equipment you selected.': 'Fälten nedan förifylls automatiskt baserat på den första utrustningen du valt.',
  'Warning: There are conflicts in the statuses or rental dates of the selected equipment. Please resolve them before saving.': 'Varning: Den valda utrustningen har olika statusar, eller så är senaste uthyrningsperioden för en utrustning redan avslutad (sista uthyrningsperioden bör alltid vara pågående). Vänligen korrigera detta separat innan du checkar ut flera utrustningar samtidigt.',
  'Use the quick add below to add a standard address to the picklist or leave blank and add your own address.': 'Använd snabbvalet nedan fr att lägga till en av de vanligaste adresserna eller lämna blankt och lägg till din egen adress.',
  'Fläta Comment Log': 'Inventeringslogg',
  'Foam Weighing': 'Skumvägning',
  'Upload foam weighing database': 'Ladda upp databasfil',
  'Upload new foam weighing database': 'Ladda upp ny databas för skumvägning',
  'Audit all marked': 'Inventera alla markerade',
  'Quick Add Picklist': 'Snabbval Plocklista',
  'Quick Add List': 'Snabbval Lista',
  'Create new Quick Add': 'Skapa nytt Snabbval',
  'Shipping Name': 'Leveransnamn',
  'Street Address': 'Gatuadress',
  'Create Quick Add': 'Skapa Snabbval',
  'Quick Add Management': 'Snabbvalshantering',
  'Requested delivery date': 'Begärt leveransdatum',
  'Weld Overview': 'Översikt svetsmaskiner'
}



// WEBPACK FOOTER //
// ./src/translations/sv.js